import { render, staticRenderFns } from "./TransferDomainModal.vue?vue&type=template&id=0f7180e4&scoped=true"
import script from "./TransferDomainModal.vue?vue&type=script&lang=js"
export * from "./TransferDomainModal.vue?vue&type=script&lang=js"
import style0 from "./TransferDomainModal.vue?vue&type=style&index=0&id=0f7180e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7180e4",
  null
  
)

export default component.exports